import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'sku-edit-category-modal--title',
    defaultMessage: 'Edit category',
  },
  viewTitle: {
    id: 'sku-edit-category-modal--view-title',
    defaultMessage: 'View category',
  },
  categoryNameLabel: {
    id: 'sku-edit-category-modal--category-name-label',
    defaultMessage: 'Category name',
  },
  menuLabel: {
    id: 'sku-edit-category-modal--menu-label',
    defaultMessage: 'Menu',
  },
  closeAriaLabel: {
    id: 'sku-edit-category-modal--close-aria-label',
    defaultMessage: 'Close',
  },
  cancel: {
    id: 'sku-edit-category-modal--cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'sku-edit-category-modal--save',
    defaultMessage: 'Save',
  },
  close: {
    id: 'sku-edit-category-modal--close',
    defaultMessage: 'Close',
  },
  categoryNameRequired: {
    id: 'sku-edit-category-modal--category-name-required',
    defaultMessage: 'Category name is required.',
  },
  categoryUpdated: {
    id: 'sku-edit-category-modal--category-updated',
    defaultMessage: '<strong>{categoryName}</strong> category was successfully updated',
  },
  categoryUpdateError: {
    id: 'sku-edit-category-modal--category-update-error',
    defaultMessage: '<strong>We were unable to update your category</strong>',
  },
  categoryUpdateErrorDescription: {
    id: 'sku-edit-category-modal--category-update-error-description',
    defaultMessage:
      'Please check your connection and try again. If this problem continues, please <contact-us-link>contact us</contact-us-link>.',
  },
  availableLabel: {
    id: 'sku-edit-category-modal--available',
    defaultMessage: 'Available',
  },
  unavailableLabel: {
    id: 'sku-edit-category-modal--unavailable',
    defaultMessage: 'Unavailable',
  },
});
